<section class="main-menu">
    <div class="container">
        <a href="{{homeUrl}}"><img class="logo" src="assets/img/logo.png" /></a>
        <ul>
            <li><a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><i class="fa fa-home"></i> Home</a></li>
            <li><a routerLink="/pricing" routerLinkActive="active"><i class="fa fa-bolt"></i> Pricing</a></li>
            <li><a href="{{dashboardUrl}}"><i class="fa fa-grip"></i> Dashboard</a></li>
        </ul>
    </div>
</section>
